/** Chip label on public event cards: prefer TICS domain, then legacy category. */

export function resolveEventListingChipLabel(input: {
  ticsDomainName?: string | null;
  category?: string | null;
  fallback?: string;
}): string {
  const fallback = input.fallback ?? 'Training';
  const domain = typeof input.ticsDomainName === 'string' ? input.ticsDomainName.trim() : '';
  if (domain) return domain;
  const category = typeof input.category === 'string' ? input.category.trim() : '';
  if (category) return category;
  return fallback;
}
